<div class="comment-item">
  @if (data.authorUsername || data.authorProfileImageUrl) {
    <div>
      <app-avatar
        [name]="data.authorUsername"
        [url]="data.authorProfileImageUrl"
      ></app-avatar>
    </div>
  }
  <div class="comment-item__content">
    @if (data.authorUsername) {
      <div class="comment-item__name">
        {{ data.authorUsername }}
        @if (data.imageReference) {
          <mat-icon>rate_review</mat-icon>
        }
      </div>
    }
    <div [innerHTML]="data.comment" class="comment-item__comment-text"></div>
  </div>
  <div>
    <div
      class="comment-item__date"
      matTooltip="{{
        data.createdAt | dateAgo : currentConfigDate : true | async
      }}"
      >
      {{ data.createdAt | dateAgo : currentConfigDate | async }}
    </div>
    <div class="comment-item__version" (click)="selected.emit()">
      {{ data.version }}
    </div>
  </div>
</div>
